import apiClient from '../../../../services/apiClient';

/** Real-time game REST endpoints (SPEC_V141_GAMES.md §3, §9). */
export const gameAPI = {
  // POST /v1/game/ws-ticket → { ticket, expiresInSec }
  getWsTicket: async () => {
    const response = await apiClient.post('/v1/game/ws-ticket');
    return response.data;
  },
  // GET /v1/pvp/info → { enabled, stakes, commissionPercent, tonBalance, heroes, recent }
  getPvpInfo: async () => {
    const response = await apiClient.get('/v1/pvp/info');
    return response.data;
  },
  // GET /v1/game/rooms/{code} → { code, game: ARENA|DURAK, hostName, stake, hostOnline, own, expiresInSec } | 404
  getRoom: async (code) => {
    const response = await apiClient.get(`/v1/game/rooms/${encodeURIComponent(code)}`, { silentError: true });
    return response.data;
  },
};

/** https://api.host[/] → wss://api.host/v1/game/ws?ticket=… (http → ws). */
export function buildGameWsUrl(ticket, baseURL = apiClient.defaults?.baseURL) {
  let base = String(baseURL || '');
  if (!/^https?:\/\//i.test(base) && typeof window !== 'undefined' && window.location) {
    base = `${window.location.origin}${base.startsWith('/') ? '' : '/'}${base}`;
  }
  const ws = base.replace(/^https:/i, 'wss:').replace(/^http:/i, 'ws:').replace(/\/+$/, '');
  return `${ws}/v1/game/ws?ticket=${encodeURIComponent(ticket)}`;
}

export default gameAPI;
